// Duck-typed rather than `instanceof HTMLElement`: a target can live in another realm (the
// TradingView chart's iframe), whose HTMLElement is a different constructor from this window's.
export function isEditableTarget(target: EventTarget | null): boolean {
  const el = target as { tagName?: string; isContentEditable?: boolean } | null
  if (!el?.tagName) return false
  return el.isContentEditable === true || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName)
}
